import styled from '@emotion/styled';
import {breakpoints, theme} from '$theme';

export const StyledCarousel = styled.div<{
    orientation?: string;
    height?: 'low' | 'normal';
    numberOfVisibleSlides?: number;
}>(
   (props) => {
        const {
            orientation = 'horizontal',
            height = 'normal',
            numberOfVisibleSlides = 1,
        } = props;
        const verticalImageHeight = height === 'low' ? 190 : 230;
        const verticalGap = 16;
        const verticalPeek = 0.15;
        const verticalCarouselHeight =
            verticalImageHeight * (numberOfVisibleSlides + verticalPeek) +
            verticalGap * numberOfVisibleSlides;
        return {
            width: '100%',
            position: 'relative',

            '.carousel-headline': {
                marginBottom: theme.space[4],
            },

            '.carousel-wrapper': {
                position: 'relative'
            },

            '.swiper-carousel': {

                width: '100%',
                height:
                    orientation === 'vertical'
                        ? `${verticalCarouselHeight}px`
                        : 'auto',
                overflow: 'hidden',
                paddingBottom: orientation === 'vertical' ? '40px' : '40px',
            },

            '.swiper-slide': {
                display: 'flex',
                height: 'auto',
            },

            '.carousel-item': {
                width: '100%',
                position: 'relative',
                overflow: 'hidden',
                textDecoration: 'none',
                borderRadius: 0,
                display: 'block',

                img: {
                    width: '100%',
                    height:
                        orientation === 'vertical'
                            ? height === 'low'
                                ? '190px'
                                : '230px'
                            : height === 'low'
                                ? '250px'
                                : '490px',
                    objectFit: 'cover',
                    display: 'block',
                },
            },
            '.carousel-item img': {
                borderRadius: 0,
            },

            '.carousel-text': {
                position: 'absolute',
                bottom: 20,
                left: 20,
                right: 20,
                color: theme.colors.white,
                zIndex: 2,

                h1: {
                    fontSize: theme.fontSizes['3xl'],
                    lineHeight: theme.lineHeights.headline,
                    fontWeight: theme.fontWeights.bold,
                    margin: 0,
                    marginBottom: theme.space[2],
                    textTransform: 'uppercase',
                    fontFamily: theme.fonts.headline,
                },

                h2: {
                    fontSize: theme.fontSizes['2xl'],
                    lineHeight: theme.lineHeights.headline,
                    fontWeight: theme.fontWeights.bold,
                    margin: 0,
                    marginBottom: theme.space[2],
                    textTransform: 'uppercase',
                    fontFamily: theme.fonts.headline,
                },

                h3: {
                    fontSize: theme.fontSizes['xl'],
                    lineHeight: theme.lineHeights.headline,
                    fontWeight: theme.fontWeights.bold,
                    margin: 0,
                    marginBottom: theme.space[2],
                    textTransform: 'uppercase',
                    fontFamily: theme.fonts.headline,
                },

                h4: {
                    fontSize: theme.fontSizes.lg,
                    lineHeight: theme.lineHeights.headline,
                    fontWeight: theme.fontWeights.bold,
                    margin: 0,
                    marginBottom: theme.space[2],
                    textTransform: 'uppercase',
                    fontFamily: theme.fonts.headline,
                },

                h5: {
                    fontSize: theme.fontSizes.md,
                    lineHeight: theme.lineHeights.headline,
                    fontWeight: theme.fontWeights.bold,
                    margin: 0,
                    marginBottom: theme.space[2],
                    textTransform: 'uppercase',
                    fontFamily: theme.fonts.headline,
                },

                p: {
                    margin: 0,
                    fontSize: theme.fontSizes.md,
                    fontFamily: theme.fonts.body,
                },
            },

            '.flip-color .carousel-text': {
                color: theme.colors.black,
            },

            '.swiper-button-prev, .swiper-button-next': {
                position: 'relative',
                top: 'auto',
                transform: 'none',
                width: '20px',
                height: '20px',
                color: theme.colors.blue,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: 'none',
                '&:hover': {
                    color: theme.colors.blue,
                    opacity: 0.7,
                    boxShadow: 'none',
                }
            },

            '.swiper-button-prev': {},
            '.swiper-button-next': {},

            '.carousel-navigation': {
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
                marginTop: orientation === 'vertical' ? '30px' : '2px',
            },

            '.swiper-button-prev::after, .swiper-button-next::after': {
                display: 'none',
            },

            '.swiper-button-prev:hover, .swiper-button-next:hover': {
                background: theme.colors.grey10,
            },

            '.swiper-pagination': {
                bottom: orientation === 'vertical' ? '-30px' : '0',
            },

            '.swiper-pagination-bullet': {
                background: theme.colors.black,
                opacity: 0.4,
            },

            '.swiper-pagination-bullet-active': {
                opacity: 1,
            },

            [breakpoints.md]: {
                '.carousel-item': {
                    img: {
                        height:
                            orientation === 'vertical'
                                ? height === 'low'
                                    ? '190px'
                                    : '230px'
                                : height === 'low'
                                    ? '310px'
                                    : '490px',
                    },
                },
            },
        }
    });